<template>
  <div :style="backgroundDivStyle">
    <v-btn
      :id="buttonId"
      class="KoioteButtonFeedback"
      :style="buttonStyle"
      @click="click"
    >
      {{ responsiveLabel }}
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "KoioteButtonFeedback",

  props: {
    input: Object,
    tank: Object,
  },

  data() {
    return {
      windowWidth: window.innerWidth,
      buttonId: "",
    };
  },

  computed: {
    ...mapState(["editing"]),

    responsiveLabel() {
      return this.windowWidth < 500 && this.input.customized?.short_label
        ? this.input.customized?.short_label
        : this.input.customized?.label;
    },

    backgroundDivStyle() {
      return {
        backgroundColor: this.retrievedColor,
        width: "100%",
        height: "100%",
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        whiteSpace: "break-spaces",
        lineHeight: "normal",
        borderRadius: "5px",
      };
    },

    buttonStyle() {
      return {
        backgroundColor: this.input.customized.background_color,
        color: this.input.customized.foreground_color,
        border: "1px solid " + this.input.customized.border_color,
        width: "90%",
        maxWidth: "90%",
        minWidth: "90%",
        height: "70%",
        textAlign: "center",
        whiteSpace: "break-spaces",
        lineHeight: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        padding: 0,
      };
    },

    write_topic() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
        ?.customized?.topic_write;
    },

    vartable() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
        ?.customized?.vartable;
    },

    value() {
      const retrievedValue = this.vartable?.find(
        (v) => v.formatted_address == this.input.customized.read_address
      )?.value;
      return retrievedValue == null || isNaN(retrievedValue) ? 0 : retrievedValue;
    },

    retrievedColor() {
      return this.value ? this.input.customized.feedback_true_color : this.input.customized.feedback_false_color;
    },

    allowed() {
      return this.input.customized?.permission_address?.length > 0
        ? this.vartable?.find((v) => v.formatted_address == this.input.customized.permission_address)?.value || 0
        : true;
    },
  },

  methods: {
    ...mapGetters(["actualPage"]),
    ...mapActions("nodered", ["doPublish"]),

    generateId() {
      return Math.random().toString(36).slice(2);
    },

    click() {
      const rawAddress = this.vartable.find((v) => v.formatted_address == this.input.customized.write_address)?.address;

      if (!this.editing && this.allowed && rawAddress){
        const description = this.tank ? `${this.input.customized.label} agitador del tanque ${this.tank?.name}` : `Depuradora en ${this.input.customized.label}`;
        this.doPublish({
          topic: this.write_topic,
          message: {
            address: rawAddress,
            value: this.input.customized.write_value,
          },
          description: description
        });
      } 
    },

    updateWidth() {
      this.windowWidth = window.innerWidth;
      const container = document.getElementById(this.buttonId);
      const containerWidth = container.getBoundingClientRect().width;

      container.classList.remove("small-text", "medium-text", "medium-large-text", "large-text");

      if (containerWidth < 60) {
        container.classList.add("small-text");
      } else if (containerWidth < 100) {
        container.classList.add("medium-text");
      } else if (containerWidth < 150) {
        container.classList.add("medium-large-text");
      } else {
        container.classList.add("large-text");
      }
    },
  },

  created() {
    this.buttonId = this.generateId();
    window.addEventListener("resize", this.updateWidth);
    this.$nextTick(() => {
      this.updateWidth();
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidth);
  },
};
</script>

<style scoped>
.small-text {
  font-size: 6px !important;
}

.medium-text {
  font-size: 9px !important;
}

.medium-large-text {
  font-size: 10px !important;
}

.large-text {
  font-size: 15px !important;
}
</style>
